var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact1"},[_c('Title',{attrs:{"title_id":"imgTitle-page-contact","title_text":_vm.$t('page-title.contact.title'),"subtitle_text":_vm.$t('page-title.contact.subtitle')}}),_c('t-contact'),_c('t-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }